import type { GridProps } from '@chakra-ui/react'
import { forwardRef, Grid } from '@chakra-ui/react'
import React from 'react'

interface PageSectionProps {
  children?: React.ReactNode
  aside?: React.ReactNode
  mainSx?: GridProps['sx']
  isLast?: boolean
}

export const PageSection = forwardRef(
  (
    { children, aside, mainSx = {}, isLast = false, ...rest }: PageSectionProps,
    ref,
  ) => {
    return (
      <Grid
        ref={ref}
        sx={{
          position: 'relative',
          alignContent: 'start',
          alignItems: 'start',
          gap: 0,
        }}
        {...rest}
      >
        {children && (
          <Grid
            as="main"
            sx={{
              gap: 16,
              alignContent: 'start',
              alignItems: 'start',
              // mb: isLast ? 0 : 16, // Do not add bottom margin when the section is last
              ...mainSx,
            }}
          >
            {children}
          </Grid>
        )}
      </Grid>
    )
  },
)
